export const csMenu = [
  {
    title: '',
    children: [
      { title: 'FAQ', path: '/cs/faq' },
      { title: '공지사항', path: '/cs/notice' },
      { title: '1:1 문의', path: '/cs/inquire' },
      //{ title: 'JM Event', path: '/events' },
    ],
  },
];
